import { client } from "../client";
import { Documentation } from "../types/documentation.types";
import { createFile } from "./file.mutations";

export const createDocumentation = async (
	documentation: Partial<Documentation>,
) => {
	// 1. Upload files
	let file = null;
	if (documentation.type === "file") {
		file = await createFile({
			file: documentation.file as File,
			fileName: undefined,
		});
	}
	// 2. Create documentation
	const response = await client.post<Documentation>(`documentations/`, {
		type: documentation.type,
		link: documentation.url ?? "",
		file: file?.id ?? null,
		title: documentation.title,
		date: documentation.date,
		category: documentation.category,
	});
	return response.data;
};

export const deleteDocumentation = async ({
	id,
}: {
	id: number | string | undefined;
}) => {
	const response = await client.delete<Documentation>(`documentations/${id}/`);
	return response.data;
};
